import { NavItem } from './nav-item/nav-item';
import {
  buildNavItems,
  VERTICAL_HOME_CONFIG,
  VERTICAL_CONFIG_ITEMS,
  VERTICAL_SETTINGS_ITEMS,
} from '../../shared/sidebar-nav.config';

export const navItems: NavItem[] = [
  {
    navCap: 'Home',
  },
  ...buildNavItems(VERTICAL_HOME_CONFIG),
  {
    navCap: 'Configuration',
  },
  ...buildNavItems(VERTICAL_CONFIG_ITEMS),
  {
    navCap: 'Settings',
  },
  ...buildNavItems(VERTICAL_SETTINGS_ITEMS),
];
